import { render, staticRenderFns } from "./CcfDashboardDetail.vue?vue&type=template&id=6865c026&"
import script from "./CcfDashboardDetail.vue?vue&type=script&lang=js&"
export * from "./CcfDashboardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports